module.exports = __webpack_public_path__ + "img/badge-list-thumb-134.14667956.png";